const updateAllocations = () => {
  const link = document.createElement("a");
  const host = window.location.host.toLowerCase();
  link.href = `${window.location.protocol}//${host}/View/Account/UpdateAnnuityAllocations`;
  link.click();
};
export default updateAllocations;
